import React from "react";
import { Typewriter } from "react-simple-typewriter";
import banner2 from "../../../assets/images/banner/banner2.jpg";
import { FaFacebookF, FaLinkedinIn, FaGithub, FaTwitter } from "react-icons/fa";
import "./Banner.css";

const Banner = () => {
  return (
    <div>
      <section
        id="bannerSection"
        style={{
          backgroundImage: `linear-gradient(to bottom, rgba(0,0,0, 0.9) 0%, rgba(0,0,0, 0.6) 100%), url(${banner2})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center bottom",
          width: "100%",
          height: "85vh",
        }}
        className="text-white relative"
      >
        <div id="stars"></div>
        <div id="stars2"></div> <div id="stars3"></div>
        <div className="container mx-auto flex flex-col items-center px-4 text-center py-32 md:px-10 lg:px-32 ">
          <h3 className="text-2xl md:text-3xl font-semibold tracking-wider uppercase">
            Welcome To My Website!
          </h3>
          <h1
            id="title"
            className=" mt-8 mb-4 text-4xl md:text-6xl font-light tracking-widest"
          >
            Motafizur Rahman
          </h1>
          <h3 className="text-2xl md:text-3xl font-semibold tracking-wider mb-5 ">
            I'm A{" "}
            <span className="text-secondary">
              {" "}
              <Typewriter
                words={[
                  "MERN Stack Developer💻",
                  "WordPress Developer❄",
                  "Self Learner📚",
                ]}
                loop={7}
                cursor
                cursorStyle="❤"
                typeSpeed={100}
                deleteSpeed={50}
                delaySpeed={1000}
              />
            </span>
          </h3>
          {/* <p className="mt-3 text-lg tracking-wide w-5/6 md:w-2/5 text-stone2">
            I'm a MERN Stack Developer and a tech enthusiast. Passionate about
            accessible web application that users love.
          </p> */}
          <ul className="flex md:block mb-5 mt-5 md:mb-0 md:mt-0 md:absolute md:top-1/3 md:left-20">
            <li className="mr-3 md:mr-0 md:mb-3">
              <a
                href="https://github.com/mostafizur131"
                rel="noreferrer"
                target="_blank"
              >
                <FaGithub className="hover:text-stone transition-all duration-200 cursor-pointer text-xl" />
              </a>
            </li>
            <li className="mr-3 md:mr-0 md:mb-3">
              <a
                href="https://www.linkedin.com/in/mostafizur131/"
                rel="noreferrer"
                target="_blank"
              >
                <FaLinkedinIn className="hover:text-stone transition-all duration-200 cursor-pointer text-xl" />
              </a>
            </li>
            <li className="mr-3 md:mr-0 md:mb-3">
              <a
                href="https://www.facebook.com/TahsinMostafiz131/"
                rel="noreferrer"
                target="_blank"
              >
                <FaFacebookF className="hover:text-stone transition-all duration-200 cursor-pointer text-xl" />
              </a>
            </li>
            <li className="mr-3 md:mr-0 md:mb-3">
              <a
                href=" https://twitter.com/mostafizur131"
                rel="noreferrer"
                target="_blank"
              >
                <FaTwitter className="hover:text-stone transition-all duration-200 cursor-pointer text-xl" />
              </a>
            </li>
          </ul>
          <div className=" mt-16 flex flex-wrap justify-center">
            <button className="px-8 py-3 m-2 text-lg font-semibold rounded-full bg-secondary text-white  hover:bg-transparent border border-secondary ">
              View Work
            </button>
            <button className="px-8 py-3 m-2 text-lg font-semibold rounded-full bg-secondary text-white  hover:bg-transparent border border-secondary ">
              Hire Me
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Banner;
